/**
 * Symptom/breakdown landing pages — high-intent queries like
 * "frigo ne refroidit plus", "lave-linge qui fuit", etc.
 */

export const PANNES = [
    // ─── LAVE-LINGE ───
    {
        slug: "lave-linge-qui-fuit",
        appliance: "lave-linge",
        applianceLabel: "Lave-linge",
        applianceServiceSlug: "reparateur-lave-linge-paris",
        h1: "Mon lave-linge fuit – Causes & réparation à domicile",
        title: "Lave-linge qui fuit : 6 causes et réparation à Paris | Electrocase",
        description: "Lave-linge qui fuit : joint de hublot, durite, pompe, bac à produits. Diagnostic à domicile sous 24 h, Paris & IDF. ☎ 01 84 80 46 86.",
        keywords: "lave-linge fuit, lave-linge fuite d'eau, machine à laver fuit, joint hublot lave-linge",
        icon: "fa-solid fa-droplet",
        urgence: "élevée",
        coutEstime: "90 € – 240 €",
        intro: "Une flaque sous votre lave-linge ? Avant de paniquer, il faut localiser l'origine de la fuite. La majorité des cas se résolvent en 1 h pour 90 à 240 €.",
        symptomes: [
            "Flaque d'eau sous l'appareil pendant ou après le cycle",
            "Goutte-à-goutte continu même hors fonctionnement",
            "Joint de hublot humide ou moisi",
            "Vibrations anormales suivies d'écoulement",
        ],
        causes: [
            { t: "Joint de hublot abîmé", d: "Le joint en caoutchouc se déchire ou se moisit avec le temps. Remplacement courant, 60 à 120 € pièce." },
            { t: "Durite percée", d: "Tuyau interne fissuré, généralement à cause du calcaire dur d'Île-de-France. Pièce + main-d'œuvre 80-130 €." },
            { t: "Pompe de vidange fissurée", d: "Choc thermique ou corps étranger. Remplacement complet pompe : 110-180 €." },
            { t: "Bac à produits engorgé", d: "Lessive durcie qui déborde par le compartiment. Nettoyage 50 €." },
            { t: "Raccord d'arrivée d'eau", d: "Joint d'étanchéité externe usé. Remplacement rapide 60 €." },
            { t: "Cuve fissurée (rare)", d: "Diagnostic obligatoire avant verdict — si confirmé, remplacement non rentable." },
        ],
        diy: [
            "Coupez l'arrivée d'eau immédiatement (robinet derrière la machine)",
            "Identifiez d'où vient la fuite : avant (joint de hublot), arrière (durites/raccords), dessous (pompe)",
            "Vérifiez le filtre de pompe en bas de l'appareil (souvent bouché par pièces de monnaie, agrafes)",
            "Photographiez la fuite avant d'appeler — gain de temps au diagnostic",
        ],
    },
    {
        slug: "lave-linge-ne-vidange-plus",
        appliance: "lave-linge",
        applianceLabel: "Lave-linge",
        applianceServiceSlug: "reparateur-lave-linge-paris",
        h1: "Lave-linge qui ne vidange plus – Diagnostic et solutions",
        title: "Lave-linge ne vidange plus : causes & réparation Paris | Electrocase",
        description: "Lave-linge bloqué avec eau au fond du tambour ? Pompe, filtre, durite, carte. Diagnostic à domicile Paris & IDF. ☎ 01 84 80 46 86.",
        keywords: "lave-linge ne vidange plus, machine à laver bloquée eau, pompe vidange lave-linge",
        icon: "fa-solid fa-arrows-up-down",
        urgence: "moyenne",
        coutEstime: "80 € – 220 €",
        intro: "Eau qui stagne au fond du tambour en fin de cycle ? 50 % du temps c'est le filtre obstrué (gratuit à nettoyer), le reste vient de la pompe ou de la durite.",
        symptomes: [
            "Eau au fond du tambour en fin de cycle",
            "Code erreur E04, F21, IE ou OE selon la marque",
            "Bruit de pompe mais pas de vidange",
            "Cycle qui s'arrête avant le rinçage",
        ],
        causes: [
            { t: "Filtre de pompe obstrué", d: "Pièces de monnaie, agrafes, élastiques de cheveux. Nettoyage 50-60 €." },
            { t: "Pompe de vidange HS", d: "Moteur grillé ou roue bloquée. Remplacement 110-180 €." },
            { t: "Durite de vidange écrasée", d: "Tuyau plié à l'installation. Repositionnement 60 €." },
            { t: "Pressostat défaillant", d: "Capteur qui ne détecte plus le niveau d'eau. Pièce + intervention 130 €." },
            { t: "Carte électronique", d: "Plus rare. Diagnostic complet nécessaire avant remplacement (140-220 €)." },
        ],
        diy: [
            "Ouvrir le petit cache en bas de la machine, dévisser le bouchon du filtre (placer une serpillière au sol)",
            "Nettoyer toutes les peluches, agrafes, pièces coincées",
            "Tester en mode vidange uniquement — 50 % des pannes se résolvent ici",
            "Vérifier que le tuyau de vidange à l'arrière n'est pas plié",
        ],
    },
    {
        slug: "lave-linge-ne-s-allume-plus",
        appliance: "lave-linge",
        applianceLabel: "Lave-linge",
        applianceServiceSlug: "reparateur-lave-linge-paris",
        h1: "Lave-linge qui ne s'allume plus – Que faire ?",
        title: "Lave-linge ne s'allume plus : 5 causes possibles | Electrocase",
        description: "Machine à laver totalement éteinte ? Prise, sécurité de porte, carte de puissance : diagnostic à domicile sous 24 h. Paris & IDF. ☎ 01 84 80 46 86.",
        keywords: "lave-linge ne s'allume plus, machine à laver éteinte, lave-linge bloc commande",
        icon: "fa-solid fa-power-off",
        urgence: "élevée",
        coutEstime: "70 € – 250 €",
        intro: "Bouton enfoncé, aucun voyant ne s'allume ? Avant de penser au pire, 3 vérifications simples peuvent vous éviter un déplacement.",
        symptomes: [
            "Aucun voyant à l'allumage",
            "Voyant qui clignote sans démarrage du cycle",
            "Disjoncteur qui saute à chaque tentative",
            "Bruit faible mais aucun mouvement",
        ],
        causes: [
            { t: "Prise / disjoncteur", d: "Souvent oublié : tester la prise avec un autre appareil. Si OK, vérifier le disjoncteur dédié." },
            { t: "Sécurité de porte HS", d: "Le système ne déclenche plus le démarrage. Remplacement 80-120 €." },
            { t: "Programmateur défectueux", d: "Bouton tournant qui n'envoie plus de signal. Pièce + main-d'œuvre 130-200 €." },
            { t: "Carte de puissance HS", d: "Souvent suite à coupure d'électricité. Diagnostic complet : 150-250 €." },
            { t: "Antiparasite grillé", d: "Pièce 25 € souvent oubliée mais cause classique. Total 80 €." },
        ],
        diy: [
            "Tester la prise avec un sèche-cheveux ou lampe — élimine le problème électrique externe",
            "Vérifier le disjoncteur du tableau électrique",
            "Appuyer fort sur la porte pour la verrouiller — défaut de fermeture courant",
            "Débrancher 5 min puis rebrancher (reset électronique)",
        ],
    },
    {
        slug: "lave-linge-tambour-bloque",
        appliance: "lave-linge",
        applianceLabel: "Lave-linge",
        applianceServiceSlug: "reparateur-lave-linge-paris",
        h1: "Tambour de lave-linge bloqué – Causes mécaniques",
        title: "Tambour lave-linge bloqué : courroie, roulements, moteur | Electrocase",
        description: "Tambour qui ne tourne plus, bruit de grincement, vibrations ? Courroie, roulements, moteur : diagnostic à domicile Paris & IDF. ☎ 01 84 80 46 86.",
        keywords: "tambour lave-linge bloqué, courroie lave-linge cassée, roulements machine à laver",
        icon: "fa-solid fa-arrows-rotate",
        urgence: "moyenne",
        coutEstime: "120 € – 280 €",
        intro: "Tambour totalement figé ou qui tourne avec un bruit métallique strident ? La cause est presque toujours mécanique — courroie, roulements ou moteur.",
        symptomes: [
            "Tambour qui ne tourne plus du tout",
            "Bruit de roulement métallique fort",
            "Grincement aigu au démarrage",
            "Tambour qui bouge à la main mais pas au cycle",
        ],
        causes: [
            { t: "Courroie cassée", d: "La plus fréquente. Remplacement 100-150 €." },
            { t: "Charbons moteur usés", d: "Sur moteurs à brosses (machines anciennes). Pièce 30 € + intervention 80 €." },
            { t: "Roulements grillés", d: "Bruit caractéristique. Réparation lourde 180-280 €, à arbitrer selon âge." },
            { t: "Condensateur de démarrage", d: "Le moteur ronronne sans tourner. Pièce 25 € + intervention 80 €." },
            { t: "Croisillon arrière fissuré", d: "Vibrations + bruit. Pièce 80-130 € + intervention." },
        ],
        diy: [
            "Faire tourner le tambour manuellement (avec un cycle annulé) — résistance anormale = roulements",
            "Écouter le bruit : aigu = roulements, grave = moteur, claquement = courroie",
            "Vérifier qu'aucun vêtement ou objet n'est coincé entre cuve et tambour",
        ],
    },
    {
        slug: "lave-linge-ne-chauffe-plus",
        appliance: "lave-linge",
        applianceLabel: "Lave-linge",
        applianceServiceSlug: "reparateur-lave-linge-paris",
        h1: "Lave-linge qui ne chauffe plus l'eau",
        title: "Lave-linge ne chauffe plus : résistance, sonde, carte | Electrocase",
        description: "Linge qui reste froid en fin de cycle ? Résistance entartrée, sonde NTC, carte de puissance : diagnostic et remplacement à domicile. ☎ 01 84 80 46 86.",
        keywords: "lave-linge ne chauffe plus, résistance lave-linge, sonde NTC",
        icon: "fa-solid fa-temperature-low",
        urgence: "faible",
        coutEstime: "100 € – 200 €",
        intro: "Cycle qui se termine avec du linge froid au lieu de chaud ? L'eau d'Île-de-France est dure : la résistance s'entartre vite et finit par griller.",
        symptomes: [
            "Linge froid en fin de cycle 40°/60°/90°",
            "Cycle qui dure plus longtemps que d'habitude",
            "Code erreur lié au chauffage selon marque",
            "Hublot qui ne chauffe pas pendant le cycle",
        ],
        causes: [
            { t: "Résistance grillée par calcaire", d: "Très fréquent en IDF (eau dure). Pièce + intervention 130-180 €." },
            { t: "Sonde NTC HS", d: "Capteur de température qui dérive. Pièce 25 € + intervention 80 €." },
            { t: "Carte de puissance", d: "Plus rare mais possible. 150-220 €." },
            { t: "Klixon de sécurité déclenché", d: "Sécurité thermique. Réarmement + nettoyage résistance 100 €." },
        ],
        diy: [
            "Lancer un cycle 90° vide avec 1 L de vinaigre blanc — détartre la résistance",
            "Vérifier si le linge ressort tiède (un peu) ou totalement froid",
            "Notez le numéro de série de la machine — facilite la commande de la résistance",
        ],
    },

    // ─── FRIGO ───
    {
        slug: "frigo-ne-refroidit-plus",
        appliance: "frigo",
        applianceLabel: "Frigo",
        applianceServiceSlug: "reparateur-frigo-paris",
        h1: "Frigo qui ne refroidit plus – Diagnostic urgent",
        title: "Frigo ne refroidit plus : 7 causes & réparation 24 h | Electrocase",
        description: "Frigo qui ne fait plus de froid alors que le moteur tourne ? Compresseur, thermostat, sonde, gaz : diagnostic urgent à domicile sous 24 h. ☎ 01 84 80 46 86.",
        keywords: "frigo ne refroidit plus, réfrigérateur ne fait plus de froid, compresseur frigo",
        icon: "fa-solid fa-snowflake",
        urgence: "très élevée",
        coutEstime: "120 € – 380 €",
        intro: "Chaque heure compte pour sauver vos aliments. Le moteur tourne mais aucun froid n'arrive ? 7 causes possibles, certaines réparables en 1 h.",
        symptomes: [
            "Moteur audible mais intérieur tiède",
            "Différence congélateur OK / réfrigérateur tiède (ou inverse)",
            "Voyant alarme ou bip continu",
            "Condensation excessive sur les parois",
        ],
        causes: [
            { t: "Condenseur encrassé", d: "Grille arrière couverte de poussière → mauvaise dissipation. Nettoyage 70 €." },
            { t: "Thermostat défectueux", d: "Pièce mécanique courante, remplacement 110-150 €." },
            { t: "Sonde de température", d: "Sur les frigos électroniques, dérive de la sonde. 120-160 €." },
            { t: "Ventilateur du compartiment", d: "Bloqué par givre. Dégivrage + remplacement 130-180 €." },
            { t: "Résistance de dégivrage HS", d: "Givre s'accumule, air ne circule plus. 150-200 €." },
            { t: "Compresseur en fin de vie", d: "Le plus coûteux. Remplacement 280-380 € — à arbitrer si > 10 ans." },
            { t: "Fuite de gaz réfrigérant", d: "Habilitation requise (cat. I). Recharge 200-300 €." },
        ],
        diy: [
            "Retirer les aliments les plus précieux et les mettre au congélateur d'un voisin si possible",
            "Vérifier que le frigo n'est pas trop chargé (mauvaise circulation d'air)",
            "Dépoussiérer la grille noire à l'arrière avec un aspirateur",
            "Mettre un thermomètre dans le frigo — note la température pour le technicien",
        ],
    },
    {
        slug: "frigo-givre-excessif",
        appliance: "frigo",
        applianceLabel: "Frigo",
        applianceServiceSlug: "reparateur-frigo-paris",
        h1: "Frigo qui fait du givre en excès",
        title: "Frigo plein de givre : causes & réparation à domicile | Electrocase",
        description: "Givre épais dans le congélateur ou compartiment froid ? Résistance de dégivrage, klixon, joint de porte : intervention à domicile Paris & IDF. ☎ 01 84 80 46 86.",
        keywords: "frigo givre, congélateur givre épais, dégivrage frigo automatique",
        icon: "fa-solid fa-icicles",
        urgence: "moyenne",
        coutEstime: "120 € – 200 €",
        intro: "Une couche de glace qui grossit chaque semaine ? C'est rarement normal. Le cycle automatique de dégivrage est en panne — 3 causes possibles.",
        symptomes: [
            "Couche de givre > 5 mm dans le congélateur",
            "Givre sur les parois du compartiment froid",
            "Joint de porte humide ou moisi",
            "Bruit de soufflerie réduit",
        ],
        causes: [
            { t: "Résistance de dégivrage HS", d: "Le cycle auto ne se déclenche plus. 130-180 €." },
            { t: "Klixon défectueux", d: "Sécurité thermique du dégivrage. 100-130 €." },
            { t: "Programmateur de dégivrage", d: "Sur frigos mécaniques. 120-160 €." },
            { t: "Joint de porte abîmé", d: "Air humide entre en permanence → givre. Remplacement 90-150 €." },
        ],
        diy: [
            "Débrancher le frigo 24 h pour dégivrage complet manuel (mettre des serpillières au sol)",
            "Tester le joint avec une feuille de papier glissée dans la porte — si elle glisse, le joint est mort",
            "Vérifier que la porte ferme bien (ouverture trop fréquente = givre)",
        ],
    },
    {
        slug: "frigo-fuite-eau",
        appliance: "frigo",
        applianceLabel: "Frigo",
        applianceServiceSlug: "reparateur-frigo-paris",
        h1: "Frigo qui fuit – Eau au sol ou dans le bac à légumes",
        title: "Frigo qui fuit : eau au sol, bac à légumes | Electrocase",
        description: "Eau qui coule sous le frigo ou dans le bac à légumes ? Durite bouchée, bac de récupération fendu, joint HS. Intervention à domicile. ☎ 01 84 80 46 86.",
        keywords: "frigo fuite d'eau, eau dans bac à légumes, durite dégivrage frigo",
        icon: "fa-solid fa-droplet",
        urgence: "moyenne",
        coutEstime: "80 € – 150 €",
        intro: "Eau au sol ou eau qui stagne dans le frigo ? C'est presque toujours la durite de dégivrage qui est bouchée. Réparation simple.",
        symptomes: [
            "Eau au sol devant ou sous le frigo",
            "Eau accumulée dans le bac à légumes",
            "Goutte-à-goutte depuis le congélateur vers le frigo",
        ],
        causes: [
            { t: "Durite de dégivrage bouchée", d: "Calcaire ou résidus alimentaires. Débouchage 80-100 €." },
            { t: "Bac de récupération fendu", d: "Vibrations du compresseur. Remplacement 100-140 €." },
            { t: "Distributeur d'eau (frigo américain)", d: "Électrovanne ou raccord HS. 120-180 €." },
            { t: "Joint de porte abîmé", d: "Idem cause givre. 90-150 €." },
        ],
        diy: [
            "Insuffler de l'air dans le petit trou au fond du congélateur (avec une poire à bébé) — débouche souvent la durite",
            "Vider le bac de récupération situé au-dessus du compresseur (à l'arrière en bas)",
        ],
    },
    {
        slug: "frigo-bruyant",
        appliance: "frigo",
        applianceLabel: "Frigo",
        applianceServiceSlug: "reparateur-frigo-paris",
        h1: "Frigo bruyant – Vibrations, ronflement, cliquetis",
        title: "Frigo qui fait du bruit : compresseur, ventilateur | Electrocase",
        description: "Frigo qui ronfle, vibre ou claque ? Compresseur, suspensions, ventilateur, condenseur : on identifie la cause sur place. Paris & IDF. ☎ 01 84 80 46 86.",
        keywords: "frigo bruyant, compresseur frigo bruit, frigo vibrations",
        icon: "fa-solid fa-volume-high",
        urgence: "faible",
        coutEstime: "70 € – 280 €",
        intro: "Un frigo neuf fait < 40 dB. Si vous l'entendez à 3 m, il y a un problème — généralement réparable.",
        symptomes: [
            "Ronflement fort au démarrage",
            "Cliquetis répétés (compresseur)",
            "Vibrations qui font trembler la cuisine",
            "Bruit de soufflerie inégal",
        ],
        causes: [
            { t: "Suspensions du compresseur HS", d: "Tampons en caoutchouc abîmés. 100-150 €." },
            { t: "Condenseur mal fixé", d: "Vibre contre la carrosserie. Resserrage 70 €." },
            { t: "Ventilateur du compartiment", d: "Roulements en fin de vie. 100-140 €." },
            { t: "Compresseur en fin de vie", d: "Bruit caractéristique en accélérant puis silence. 230-280 €." },
        ],
        diy: [
            "Vérifier que le frigo est de niveau (utiliser un niveau à bulles)",
            "Espacer le frigo de 5 cm minimum du mur (besoin d'air arrière)",
            "Stabiliser sur des patins anti-vibrations (15 €)",
        ],
    },

    // ─── LAVE-VAISSELLE ───
    {
        slug: "lave-vaisselle-ne-vidange-plus",
        appliance: "lave-vaisselle",
        applianceLabel: "Lave-vaisselle",
        applianceServiceSlug: "reparateur-lave-vaisselle-paris",
        h1: "Lave-vaisselle qui ne vidange plus",
        title: "Lave-vaisselle ne vidange plus : pompe, filtre, code E15 | Electrocase",
        description: "Eau stagnante au fond du lave-vaisselle, code erreur E15 / E24 ? Filtre, pompe, durite : diagnostic à domicile sous 24 h. Paris & IDF. ☎ 01 84 80 46 86.",
        keywords: "lave-vaisselle ne vidange plus, lave-vaisselle code E15, pompe vidange lave-vaisselle",
        icon: "fa-solid fa-arrows-up-down",
        urgence: "élevée",
        coutEstime: "80 € – 200 €",
        intro: "Eau au fond en fin de cycle, ou code E15/E24 affiché ? 60 % des cas se résolvent en 30 minutes par nettoyage du filtre.",
        symptomes: [
            "Eau stagnante au fond en fin de cycle",
            "Code erreur E15, E24, E22 ou E25 selon marque",
            "Bruit de pompe sans évacuation",
            "Lave-vaisselle qui s'arrête en plein cycle",
        ],
        causes: [
            { t: "Filtre central encrassé", d: "Résidus, os, verre brisé. Nettoyage gratuit ou intervention 50 €." },
            { t: "Pompe de vidange bloquée", d: "Verre brisé coincé. 110-160 €." },
            { t: "Durite de vidange bouchée", d: "Calcaire / graisses. Débouchage 80-100 €." },
            { t: "Capteur de pression HS", d: "Le LV pense qu'il y a de l'eau alors qu'il n'y en a plus. 130-180 €." },
            { t: "Code E15 (présence eau dans le socle)", d: "Fuite interne — à traiter rapidement. 150-200 €." },
        ],
        diy: [
            "Sortir le filtre central (en bas), démonter, rincer à l'eau chaude, remettre",
            "Mettre une serpillière sous l'appareil et inspecter la pompe (accessible par-dessous)",
            "Lancer un cycle court vide avec du vinaigre blanc — détartre",
        ],
    },
    {
        slug: "lave-vaisselle-ne-chauffe-plus",
        appliance: "lave-vaisselle",
        applianceLabel: "Lave-vaisselle",
        applianceServiceSlug: "reparateur-lave-vaisselle-paris",
        h1: "Lave-vaisselle qui ne chauffe plus l'eau",
        title: "Lave-vaisselle ne chauffe plus : résistance & sonde | Electrocase",
        description: "Vaisselle qui ressort froide ou mal lavée ? Résistance, sonde NTC, carte de puissance : diagnostic à domicile. Paris & IDF. ☎ 01 84 80 46 86.",
        keywords: "lave-vaisselle ne chauffe plus, résistance lave-vaisselle, vaisselle froide",
        icon: "fa-solid fa-temperature-low",
        urgence: "faible",
        coutEstime: "120 € – 220 €",
        intro: "Vaisselle qui ressort froide et mal lavée, ou cycle qui dure 3 h au lieu de 1 h 30 ? La résistance est probablement HS.",
        symptomes: [
            "Vaisselle froide en fin de cycle",
            "Cycle anormalement long",
            "Vaisselle mal séchée",
            "Code erreur lié au chauffage",
        ],
        causes: [
            { t: "Résistance entartrée", d: "Eau dure d'IDF → entartrage rapide. 130-180 €." },
            { t: "Sonde NTC", d: "Capteur de température dérive. 110-150 €." },
            { t: "Klixon thermique déclenché", d: "Sécurité activée. 100-130 €." },
            { t: "Carte de puissance", d: "Pilote du chauffage HS. 180-220 €." },
        ],
        diy: [
            "Lancer un cycle vide avec du nettoyant lave-vaisselle (Sun Power, Calgonit) — détartre",
            "Vérifier le sel régénérant (à mettre tous les 2-3 mois en IDF)",
        ],
    },
    {
        slug: "lave-vaisselle-fuit",
        appliance: "lave-vaisselle",
        applianceLabel: "Lave-vaisselle",
        applianceServiceSlug: "reparateur-lave-vaisselle-paris",
        h1: "Lave-vaisselle qui fuit – Origine & réparation",
        title: "Lave-vaisselle qui fuit : joints, durite, électrovanne | Electrocase",
        description: "Eau sous le lave-vaisselle ou sur le plan de travail ? Joints, électrovanne, durite, cuve : intervention à domicile. Paris & IDF. ☎ 01 84 80 46 86.",
        keywords: "lave-vaisselle fuite, joint porte lave-vaisselle, électrovanne lave-vaisselle",
        icon: "fa-solid fa-droplet",
        urgence: "élevée",
        coutEstime: "90 € – 230 €",
        intro: "Une fuite de lave-vaisselle abîme rapidement les meubles bas et le sol. Intervention rapide indispensable.",
        symptomes: [
            "Flaque devant ou sous l'appareil",
            "Humidité dans les meubles bas voisins",
            "Code erreur E15 (eau dans le socle)",
            "Goutte-à-goutte par la porte",
        ],
        causes: [
            { t: "Joint de porte abîmé", d: "Usure normale après 5 ans. 100-140 €." },
            { t: "Durite interne fissurée", d: "130-180 €." },
            { t: "Électrovanne défectueuse", d: "Eau qui continue d'entrer même cycle arrêté. 140-200 €." },
            { t: "Pompe fissurée", d: "150-220 €." },
            { t: "Cuve trouée (rare)", d: "Diagnostic complet — souvent non rentable." },
        ],
        diy: [
            "Couper l'arrivée d'eau (robinet sous l'évier)",
            "Vider la cuve, sécher complètement, lancer un cycle court pour localiser la fuite",
            "Photographier la fuite avant l'arrivée du technicien",
        ],
    },
    {
        slug: "lave-vaisselle-vaisselle-sale",
        appliance: "lave-vaisselle",
        applianceLabel: "Lave-vaisselle",
        applianceServiceSlug: "reparateur-lave-vaisselle-paris",
        h1: "Vaisselle sale en fin de cycle – Causes possibles",
        title: "Lave-vaisselle qui lave mal : bras, pompe, résistance | Electrocase",
        description: "Vaisselle mal lavée, traces, sel mal dosé ? Bras de lavage, pompe de cyclage, résistance : diagnostic complet. Paris & IDF. ☎ 01 84 80 46 86.",
        keywords: "lave-vaisselle lave mal, vaisselle sale lave-vaisselle, bras de lavage bloqué",
        icon: "fa-solid fa-utensils",
        urgence: "faible",
        coutEstime: "70 € – 200 €",
        intro: "Vaisselle qui ressort sale ou avec des traces ? Avant d'appeler, vérifiez le sel et le liquide de rinçage. Sinon, c'est plus technique.",
        symptomes: [
            "Restes alimentaires sur la vaisselle",
            "Traces blanches / calcaire",
            "Vaisselle non séchée",
            "Bras de lavage qui ne tourne pas",
        ],
        causes: [
            { t: "Bras de lavage bouché", d: "Gicleurs entartrés. Nettoyage 70 €." },
            { t: "Pompe de cyclage HS", d: "Pression insuffisante. 150-200 €." },
            { t: "Adoucisseur HS", d: "Sel non régénéré → vaisselle blanchâtre. Réparation 130-170 €." },
            { t: "Doseur de produit", d: "Tablette non dissoute. Remplacement 100-150 €." },
        ],
        diy: [
            "Vérifier que vous mettez bien du sel régénérant (compartiment dédié)",
            "Régler le doseur de liquide de rinçage",
            "Nettoyer les bras de lavage à l'eau chaude (les démonter facilement)",
        ],
    },

    // ─── FOUR ───
    {
        slug: "four-ne-chauffe-plus",
        appliance: "four",
        applianceLabel: "Four",
        applianceServiceSlug: "reparation-four-paris",
        h1: "Four électrique qui ne chauffe plus",
        title: "Four ne chauffe plus : résistance, thermostat, sélecteur | Electrocase",
        description: "Four électrique qui n'atteint plus la bonne température ? Résistance voûte/sole, thermostat, sélecteur : intervention à domicile. Paris & IDF. ☎ 01 84 80 46 86.",
        keywords: "four ne chauffe plus, résistance four grillée, thermostat four",
        icon: "fa-solid fa-fire",
        urgence: "faible",
        coutEstime: "100 € – 220 €",
        intro: "Le four affiche 200° mais le plat ne cuit pas ? Plusieurs résistances peuvent être en cause selon le mode (chaleur tournante, gril, sole).",
        symptomes: [
            "Plats qui ne cuisent pas / pas assez",
            "Une seule résistance fonctionne (gril sans voûte par ex.)",
            "Cycle pyrolyse qui ne se déclenche pas",
            "Affichage OK mais aucune chaleur",
        ],
        causes: [
            { t: "Résistance grillée", d: "Voûte, sole ou chaleur tournante. Pièce 50-100 € + intervention 80 € = 130-180 €." },
            { t: "Thermostat HS", d: "Pièce 40 € + intervention 80 € = 120-150 €." },
            { t: "Sélecteur de fonctions", d: "Bouton défectueux. 140-200 €." },
            { t: "Carte de puissance", d: "Plus rare. 180-220 €." },
        ],
        diy: [
            "Tester chaque mode séparément (voûte, sole, gril, chaleur tournante) — identifier la résistance défectueuse",
            "Vérifier qu'aucun fusible n'a sauté",
            "Inspecter visuellement les résistances : une cassée se voit (filament coupé)",
        ],
    },
    {
        slug: "four-porte-bloquee",
        appliance: "four",
        applianceLabel: "Four",
        applianceServiceSlug: "reparation-four-paris",
        h1: "Porte de four bloquée – Pyrolyse, charnières, verrou",
        title: "Porte four bloquée après pyrolyse : déblocage à domicile | Electrocase",
        description: "Porte de four bloquée après cycle pyrolyse ? Verrou thermique, charnières, capteur : déblocage et réparation à domicile. Paris & IDF. ☎ 01 84 80 46 86.",
        keywords: "porte four bloquée, four pyrolyse porte bloquée, charnières four",
        icon: "fa-solid fa-lock",
        urgence: "moyenne",
        coutEstime: "90 € – 180 €",
        intro: "Porte de four qui reste verrouillée après pyrolyse, ou charnière cassée ? Ne forcez pas — appelez avant d'aggraver.",
        symptomes: [
            "Porte bloquée même four froid",
            "Charnières grippées ou cassées",
            "Verrou thermique qui ne se libère pas",
            "Code erreur lié au verrouillage",
        ],
        causes: [
            { t: "Verrou thermique HS (pyrolyse)", d: "120-160 €." },
            { t: "Charnières cassées ou grippées", d: "Pièce 60-100 € + intervention 80 €." },
            { t: "Capteur de fermeture", d: "Le four pense qu'il est en pyrolyse. 100-140 €." },
        ],
        diy: [
            "Ne JAMAIS forcer la porte — risque de casser la vitre intérieure",
            "Patienter 1-2 h après la fin du cycle pyrolyse (refroidissement obligatoire)",
            "Tester un cycle court (10 min, 100°) puis refroidissement complet",
        ],
    },
    {
        slug: "micro-ondes-ne-chauffe-plus",
        appliance: "four",
        applianceLabel: "Micro-ondes",
        applianceServiceSlug: "reparation-four-paris",
        h1: "Micro-ondes qui ne chauffe plus – Magnétron, diode",
        title: "Micro-ondes ne chauffe plus : magnétron, diode | Electrocase",
        description: "Micro-ondes qui tourne mais ne chauffe plus l'eau ? Magnétron, diode haute tension, transformateur : intervention sécurisée à domicile. ☎ 01 84 80 46 86.",
        keywords: "micro-ondes ne chauffe plus, magnétron, micro-ondes ne réchauffe pas",
        icon: "fa-solid fa-bolt",
        urgence: "faible",
        coutEstime: "100 € – 180 €",
        intro: "Le plateau tourne, la lumière s'allume, mais l'aliment reste froid ? Le magnétron est probablement en cause. Diagnostic haute tension obligatoire.",
        symptomes: [
            "Aliment froid en fin de cycle",
            "Bruit anormal (transformateur)",
            "Étincelles à l'intérieur",
            "Disjoncteur qui saute",
        ],
        causes: [
            { t: "Magnétron HS", d: "Élément générateur des ondes. 140-180 €." },
            { t: "Diode haute tension", d: "Composant courant. 100-130 €." },
            { t: "Condensateur HT", d: "Pièce dangereuse — interdiction d'y toucher sans habilitation. 120-160 €." },
            { t: "Transformateur HT", d: "Pièce lourde et chère. 160-200 €." },
        ],
        diy: [
            "Tester avec un verre d'eau (200 ml) pendant 1 min — si l'eau ne chauffe pas, c'est confirmé",
            "Ne JAMAIS ouvrir un micro-ondes soi-même — haute tension persistante même débranché",
        ],
    },

    // ─── SECHE-LINGE ───
    {
        slug: "seche-linge-ne-chauffe-plus",
        appliance: "seche-linge",
        applianceLabel: "Sèche-linge",
        applianceServiceSlug: "reparation-seche-linge-paris",
        h1: "Sèche-linge qui ne chauffe plus",
        title: "Sèche-linge ne chauffe plus : résistance, klixon | Electrocase",
        description: "Sèche-linge qui tourne mais ne chauffe plus ? Résistance, klixon, sonde, PAC : diagnostic à domicile par technicien certifié. Paris & IDF. ☎ 01 84 80 46 86.",
        keywords: "sèche-linge ne chauffe plus, résistance sèche-linge, pompe à chaleur sèche-linge",
        icon: "fa-solid fa-temperature-low",
        urgence: "faible",
        coutEstime: "120 € – 250 €",
        intro: "Le tambour tourne, l'horloge tourne, mais le linge ressort humide ? La cause varie selon le type (condensation, évacuation, pompe à chaleur).",
        symptomes: [
            "Linge humide en fin de cycle",
            "Cycle qui dure indéfiniment",
            "Air froid sortant à la place d'air chaud",
            "Code erreur lié au chauffage",
        ],
        causes: [
            { t: "Résistance grillée (condensation/évacuation)", d: "150-200 €." },
            { t: "Klixon thermique déclenché", d: "Sécurité réarmable. 100-130 €." },
            { t: "Sonde NTC HS", d: "120-150 €." },
            { t: "Pompe à chaleur HS (sèche-linge PAC)", d: "Diagnostic spécifique. 200-250 € (si réparable)." },
            { t: "Filtre / évaporateur encrassé (PAC)", d: "Nettoyage 100-130 €." },
        ],
        diy: [
            "Nettoyer le filtre à peluches après chaque cycle (cause #1 de surchauffe → klixon)",
            "Vérifier la grille d'aération arrière",
            "Sur PAC : nettoyer l'évaporateur (accessible par cache amovible)",
        ],
    },
    {
        slug: "seche-linge-bac-plein",
        appliance: "seche-linge",
        applianceLabel: "Sèche-linge",
        applianceServiceSlug: "reparation-seche-linge-paris",
        h1: "Sèche-linge bac plein affiché en permanence",
        title: "Sèche-linge bac plein en permanence : pompe relevage | Electrocase",
        description: "Voyant bac plein affiché alors que le bac est vide ? Pompe de relevage, capteur, durite : intervention à domicile. Paris & IDF. ☎ 01 84 80 46 86.",
        keywords: "sèche-linge bac plein, voyant bac plein, pompe relevage sèche-linge",
        icon: "fa-solid fa-water",
        urgence: "moyenne",
        coutEstime: "100 € – 180 €",
        intro: "Voyant 'bac plein' alors que vous venez de le vider ? Le capteur ou la pompe de relevage est en panne.",
        symptomes: [
            "Voyant 'bac plein' allumé en permanence",
            "Eau qui s'accumule dans le bac inférieur",
            "Cycle qui s'arrête prématurément",
        ],
        causes: [
            { t: "Pompe de relevage bloquée", d: "Cause #1. 120-160 €." },
            { t: "Capteur de niveau HS", d: "Faux signal de bac plein. 110-140 €." },
            { t: "Durite de relevage bouchée", d: "Peluches accumulées. Débouchage 80-100 €." },
            { t: "Filtre à condensation encrassé", d: "Air bloqué → eau qui stagne. Nettoyage 60 €." },
        ],
        diy: [
            "Retirer le bac, le vider même s'il semble vide",
            "Nettoyer le filtre à condensation (souvent oublié, à l'arrière du tambour)",
            "Vérifier que la durite de relevage n'est pas pliée",
        ],
    },
];

export const findPanne = (slug) => PANNES.find((p) => p.slug === slug);
